import { render, staticRenderFns } from "./heshikyjx.vue?vue&type=template&id=c6ba3f3c&scoped=true"
import script from "./heshikyjx.vue?vue&type=script&lang=js"
export * from "./heshikyjx.vue?vue&type=script&lang=js"
import style0 from "./heshikyjx.vue?vue&type=style&index=0&id=c6ba3f3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ba3f3c",
  null
  
)

export default component.exports